import { render, staticRenderFns } from "./picker-panel.vue?vue&type=template&id=aa0dea20&scoped=true&"
import script from "./picker-panel.vue?vue&type=script&lang=js&"
export * from "./picker-panel.vue?vue&type=script&lang=js&"
import style0 from "./picker-panel.vue?vue&type=style&index=0&id=aa0dea20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../kuaishou-frontend-collect/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0dea20",
  null
  
)

export default component.exports